import { api } from './api';

export const addressService = {
  list:    ()        => api.get('/api/addresses',       { includeStore: false }),
  create:  (payload) => api.post('/api/addresses', payload, { includeStore: false }),
  update:  (id, p)   => api.patch(`/api/addresses/${id}`, p, { includeStore: false }),
  remove:  (id)      => api.delete(`/api/addresses/${id}`, { includeStore: false })
};

export default addressService;
